export const heroWeaponColor = '0x797979';
